export enum GeoTestPersistenceStatus {
  noOp = 'NoOp',
  studyCreated = 'studyCreated',
  studyUpdated = 'studyUpdated',
  studyRemoved = 'studyRemoved'
}
